import { render } from "./Student.vue?vue&type=template&id=700eba75&bindings={}"
import script from "./Student.vue?vue&type=script&lang=ts"
export * from "./Student.vue?vue&type=script&lang=ts"
script.render = render

export default script